    /* tslint:disable no-invalid-this */

    import {
    IEditor, IEditorCanvas,
    IEditorEditorGroup, IEditorPage,
    IEditorPageGroup,
    IEditorShape,
    Imports, IPostRender,
    ITransform
} from "./editor.interfaces";
    import {commonEventInfo, FabricHelpers, getLocalMouse} from "@/editor/base/fabric-helpers";
    import {EditorHelpers} from "@/editor/base/helpers";

    const INNER_ROTATION = 'ir';
    const OUTER_ROTATION = 'mtr';
    const CONTROL_PAN = 'pan';
    const GRAB_HANDLE_TOP_RIGHT = 'tr';
    const GRAB_HANDLE_TOP_LEFT = 'tl';
    const GRAB_HANDLE_BOTTOM_LEFT = 'bl';
    const GRAB_HANDLE_BOTTOM_RIGHT = 'br';
    const GRAB_HANDLE_MIDDLE_TOP = 'mt';
    const GRAB_HANDLE_MIDDLE_BOTTOM = 'mb';

    const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;
    const SF = globalImports.SF || {};
    globalImports.SF.Editor = globalImports.SF.Editor || {} as IEditor;

    const fabric = globalImports.fabric;

    const rotateCursor = encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>'
    );

    const rotateControlImg = fabric.util.createImage();
    const cornerControlImg = fabric.util.createImage();
    const panControlImg = fabric.util.createImage();

    cornerControlImg.src = SF.staticUrlRoot + 'images/editor/icons/svg/grab_handle.svg';
    rotateControlImg.src = SF.staticUrlRoot + 'images/editor/icons/svg/grab_handle_rotate.svg';
    panControlImg.src = SF.staticUrlRoot + 'images/editor/icons/icon_hand_open.png';

    const setCoords = fabric.Object.prototype.setCoords;

    /* tslint:disable variable-name */
    const WrapOptions = globalImports.SF.Model.WrapOptions;
    const HandleLayout = globalImports.SF.Model.HandleLayout;
    const EditorBleedProperties = globalImports.SF.Model.EditorBleedProperties;
    /* tslint:enable variable-name */

    SF.Editor = SF.Editor || {} as IEditor;

    // are we showing a mobile layout
    // @ts-ignore
    fabric.Object.prototype.set({ handleLayout: typeof (NewUI) != 'undefined' && NewUI.isTouchOnly() ? HandleLayout.MOBILE : HandleLayout.DEFAULT });

    const defaultSettings = {
        originX: 'center',
        originY: 'center',
        transparentCorners: false,
        cornerColor: 'rgb(255,102,0)',
        cornerSize: 10,
        cornerStyle: 'rect',
        rotatingPointOffset: 25,
        innerRotateOffset: -25,
        borderColor: 'black',
        order: 0,
        padding: 1,
        maxTextureSize: 4096,
        rotateControlSize: 20,
        controlSize: 15,
        panControlSize: 25,
    };

    // Protect window from node (jrs)
    if (fabric.Object.prototype.handleLayout == HandleLayout.MOBILE) {
        defaultSettings.cornerStyle = 'circle';
        defaultSettings.cornerColor = 'green';
        defaultSettings.cornerSize = (fabric.Object.prototype.handleLayout == HandleLayout.MOBILE) ? 30 : screen.width * 0.04;
        defaultSettings.rotatingPointOffset = defaultSettings.rotatingPointOffset + defaultSettings.cornerSize / 2;
        defaultSettings.innerRotateOffset = defaultSettings.innerRotateOffset - defaultSettings.cornerSize / 2;
    }

    // we are extending fabric.js functionality
    // set defaults for the objects as well
    fabric.Object.prototype.set(defaultSettings);

    fabric.Object.prototype.objectCaching = false;

    /////////////////////////////////
    // OVERRIDE CONTROL VISIBILITY //
    /////////////////////////////////
    // const parentIsControlVisible = fabric.Object.prototype.isControlVisible;
    fabric.Object.prototype.isControlVisible = function (name: string): boolean {
        if ((this.locked === true || this.fixed === true) && name !== INNER_ROTATION && name !== CONTROL_PAN) {
            return false;
        }
        return this._getControlsVisibility()[name];
    };

    ////////////////////////////
    // OVERRIDE OBJECT SETTER //
    ////////////////////////////
    const objectSet = fabric.Object.prototype._set;

    fabric.Object.prototype._set = function (key: string, value: any): any {
        if (key === 'locked' || key === 'fixed') {
            this.set({
                _originalHoverCursor: this.hoverCursor,
                lockMovementX: value,
                lockMovementY: value,
                lockScalingX: value,
                lockScalingY: value,
                hoverCursor: value ? 'initial' : (this._originalHoverCursor || this.hoverCursor)
            });
        }

        return objectSet.call(this, key, value);
    };

    fabric.Object.prototype.isNonMovableBackground = function (): boolean {
        return false;
    };

    fabric.Object.prototype.disableDashedBorder = function (): boolean {
        return false;
    };

    fabric.Object.prototype.drawWarningErrorContainer  = function(ctx: CanvasRenderingContext2D, warningText: string,
          warningTopInitial: number, warningLeftInitial: number, containerColor: string, textColor: string,
          iconWidth: number, textHeight:number = 24, fontName:string = 'Arial'):void  {

        ctx.font = `bold ${Math.round(textHeight/2)}px ${fontName}`;
        // Measure the text width and height
        const textMetrics = ctx.measureText(warningText);
        const textWidth = textMetrics.width;

        // Define the container dimensions
        const containerWidth = textWidth + (textHeight / 2);
        const containerHeight = textHeight + 2;
        const warningTop = warningTopInitial - containerHeight - 2;
        let warningLeft = warningLeftInitial + 2;

        // Define the triangle dimensions
        const triangleWidth = Math.round(textHeight / 1.6);
        const triangleHeight = containerHeight / 2;

        const transform = ctx.getTransform();
        const canvasX = transform.e / transform.a;
        // Set the container and triangle color

        ctx.fillStyle = containerColor; // warning color
        ctx.beginPath();

        if (canvasX + warningLeft + textWidth > (ctx.canvas.width / transform.a)) {

            warningLeft = warningLeft - containerWidth - iconWidth - 4;
            // Draw the triangle on the right side at the specified position
            ctx.moveTo(warningLeft + containerWidth + triangleWidth, warningTop + containerHeight / 2);
            ctx.lineTo(warningLeft + containerWidth, warningTop + (containerHeight - triangleHeight) / 2);
            ctx.lineTo(warningLeft + containerWidth, warningTop + (containerHeight + triangleHeight) / 2);
        } else {
            // Draw the triangle on the left side at the specified position
            ctx.moveTo(warningLeft, warningTop + containerHeight / 2);
            ctx.lineTo(warningLeft + triangleWidth, warningTop + (containerHeight - triangleHeight) / 2);
            ctx.lineTo(warningLeft + triangleWidth, warningTop + (containerHeight + triangleHeight) / 2);
            // Move the container to right of the triangle
            warningLeft = warningLeft + triangleWidth;
        }

        ctx.closePath();
        ctx.fill();

        ctx.fillRect(warningLeft, warningTop, containerWidth, containerHeight);

        // Draw the text inside the container at the specified position
        ctx.fillStyle = textColor; // Text color
        ctx.fillText(warningText, warningLeft + 5, warningTop + containerHeight / 2 + textHeight / 4);
    };

    // Draw Borders
    /**
     * TODO: this can probably be greatly simplified...
     *
     * @param ctx
     */
    fabric.Object.prototype.drawBorders = function (ctx: CanvasRenderingContext2D): fabric.Object {
        if (!this.hasBorders || this.pattern) {
            return this;
        }

        if (this.group && this.group.type == 'group' && this.canvas.getObjects().indexOf(this.group._findGroupByUid(this.canvas)) >= 0) {
            return this;

        }

        const padding = this.padding;
        const padding2 = padding * 2;
        const vpt = this.getViewportTransform();
        ctx.save();
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        this._setLineDash(ctx, this.borderDashArray, null);
        if (this.type == 'sf-text') {
            this.borderColor = this.fill;
        }
        ctx.strokeStyle = this.borderColor;

        const scaleX = 1 / this._constrainScale(this.scaleX);
        const scaleY = 1 / this._constrainScale(this.scaleY);

        let width: number;
        let height: number;

        const editsManager = this.canvas.editsManager;

        const currentPage = editsManager ? editsManager.getCurrentPage() : null;

        // We get width and height from the edits if it's a background.
        if (this instanceof SF.Editor.Background && this.canvas.wrap && this.canvas.state && this.canvas.state.showWrap) {
            width = currentPage.width;
            height = currentPage.height;
        } else if (this instanceof SF.Editor.Background
            && editsManager && currentPage.type == SF.Model.PageTypes.SPINE
            && this.width > currentPage.width) {
            const visiblePages = editsManager.getVisiblePages();
            let totalWidth = 0;
            for (let i = 0; i < visiblePages.length; i++) {
                totalWidth += visiblePages[i].width;
            }
            if (totalWidth == this.width) {
                width = this.width;
                height = this.height;
            } else {
                width = this.width - currentPage.width;
                height = this.height;
            }

        } else if (this.mainType && this.mainType == 'shapeAsset') {
            if (this.type !== SF.Model.ShapeAssetTypes.Rectangle && this.type !== SF.Model.ShapeAssetTypes.Triangle) {
                width = this.getScaledWidth();
                height = this.getScaledHeight();
            } else {
                width = this.width;
                height = this.height;
            }

        } else {
            width = this.getScaledWidth();
            height = this.getScaledHeight();
        }
        const strokeWidth = this.strokeWidth > 1 ? this.strokeWidth : 0;
        const capped = this.strokeLineCap === 'round' || this.strokeLineCap === 'square';
        const vLine = this.type === 'line' && this.width === 1;
        const hLine = this.type === 'line' && this.height === 1;
        const strokeW = (capped && hLine) || this.type !== 'line';
        const strokeH = (capped && vLine) || this.type !== 'line';

        if (vLine) {
            width = strokeWidth / scaleX;
        } else if (hLine) {
            height = strokeWidth / scaleY;
        }

        if (strokeW) {
            width += strokeWidth / scaleX;
        }

        if (strokeH) {
            height += strokeWidth / scaleY;
        }

        const transformedWidthHeight = fabric.util.transformPoint(new fabric.Point(width, height), vpt, true);

        let transformedWidth = transformedWidthHeight.x;
        let transformedHeight = transformedWidthHeight.y;

        if (this.group) {
            transformedWidth = transformedWidth * this.group.scaleX;
            transformedHeight = transformedHeight * this.group.scaleY;
        }

        // code to draw dashed array stolen from drawSelection
        if (!this.disableDashedBorder()) {
            ctx.beginPath();
            const wrap = this.canvas.wrap;
            let wrapAdjustmentWidth = 0;
            let wrapAdjustmentHeight = 0;
            let wrapLeft = 0;
            let wrapTop = 0;

            if (this.canvas.wrap && this.canvas.state && this.canvas.state.showWrap && this instanceof SF.Editor.Background) {
                const totalWidth = transformedWidth;
                const totalHeight = transformedHeight;
                transformedWidth -= (wrap[EditorBleedProperties.BLEED_SIDE_LEFT] + wrap[EditorBleedProperties.BLEED_BACK_LEFT] + wrap[EditorBleedProperties.BLEED_SIDE_RIGHT] + wrap[EditorBleedProperties.BLEED_BACK_RIGHT]) * this.canvas.getZoom();
                transformedHeight -= (wrap[EditorBleedProperties.BLEED_SIDE_TOP] + wrap[EditorBleedProperties.BLEED_BACK_TOP] + wrap[EditorBleedProperties.BLEED_SIDE_BOTTOM] + wrap[EditorBleedProperties.BLEED_BACK_BOTTOM]) * this.canvas.getZoom();
                wrapAdjustmentWidth = totalWidth - transformedWidth;
                wrapAdjustmentHeight = totalHeight - transformedHeight;
                wrapLeft = (wrap[EditorBleedProperties.BLEED_SIDE_LEFT] + wrap[EditorBleedProperties.BLEED_BACK_LEFT]) * this.canvas.getZoom();
                wrapTop = (wrap[EditorBleedProperties.BLEED_SIDE_TOP] + wrap[EditorBleedProperties.BLEED_BACK_TOP]) * this.canvas.getZoom();
            }

            const px = Math.floor(-(transformedWidth / 2) - wrapAdjustmentWidth / 2 + wrapLeft - padding) - 0.5;
            const py = Math.floor(-(transformedHeight / 2) - wrapAdjustmentHeight / 2 + wrapTop - padding) - 0.5;
            const pwidth = Math.floor(transformedWidth + padding2) + 1;
            const pheight = Math.floor(transformedHeight + padding2) + 1;

            ctx.setLineDash([3]);
            ctx.strokeRect(px, py, pwidth, pheight);

            ctx.closePath();
            ctx.stroke();
        }
        let rotateHeight;

        if (this.hasControls && this.controls.mtr && this.isControlVisible(OUTER_ROTATION) && !this.get('lockRotation')) {

            rotateHeight = (-transformedHeight - (padding * 2)) / 2;
            ctx.beginPath();
            ctx.moveTo(0, rotateHeight);
            ctx.lineTo(0, rotateHeight - this.rotatingPointOffset);
            ctx.closePath();
            ctx.stroke();
        }

        // draw internal rotator line - TODO: maybe switch from hasInnerRotatingPoint to this.controls.ir and this._controlVisbililty.ir to be consistent
        if (this.hasControls && this.hasInnerRotatingPoint && this.isControlVisible(INNER_ROTATION) &&
            !this.get('lockRotation') && this.photoObject && this.photoObject.image && !this.isNonMovableBackground()) {

            rotateHeight = (-transformedHeight - (padding * 2)) / 2;
            ctx.beginPath();
            ctx.moveTo(0, rotateHeight);
            ctx.lineTo(0, rotateHeight - this.innerRotateOffset);
            ctx.closePath();
            ctx.stroke();
        }

        ctx.restore();
        return this;
    };

    function calcBrightness(r: number, g: number, b: number): number {
        return (r * 299 + g * 587 + b * 114) / 1000;
    }

    function isBrighterThan(r: number, g: number, b: number, brightnessValue: number): boolean {
        return (calcBrightness(r, g, b) > brightnessValue);
    }

    function getAverageRGBColor(data: Uint8ClampedArray, blockSize: number): {
        r: number,
        g: number,
        b: number,
        a: number
    } {
        const length = data.length;
        let i = 0;
        let count = 0;
        const rgb = { r: 0, g: 0, b: 0, a: 0 };

        while ((i += blockSize * 4) < length) {
            ++count;
            rgb.r += Math.pow(data[i] / 255, 2);
            rgb.g += Math.pow(data[i + 1] / 255, 2);
            rgb.b += Math.pow(data[i + 2] / 255, 2);
            rgb.a += Math.pow(data[i + 3] / 255, 2);
        }

        rgb.r = Math.sqrt(rgb.r / count);
        rgb.g = Math.sqrt(rgb.g / count);
        rgb.b = Math.sqrt(rgb.b / count);
        rgb.a = Math.sqrt(rgb.a / count);

        rgb.r = ((1 - rgb.a) + rgb.a * rgb.r) * 255;
        rgb.g = ((1 - rgb.a) + rgb.a * rgb.g) * 255;
        rgb.b = ((1 - rgb.a) + rgb.a * rgb.b) * 255;

        return rgb;
    }

    ///////////////////
    // Draw Controls //
    ///////////////////
    fabric.Object.prototype.drawBordersInGroup = function (ctx: CanvasRenderingContext2D, options: any, styleOverride: any): any {
        if (this.group && this.group.type == 'group' && this.canvas && this.canvas.getObjects().indexOf(this.group._findGroupByUid(this.canvas)) >= 0) {
            return this;
        } else {
            styleOverride = styleOverride || {};
            const p = this._getNonTransformedDimensions();
            const matrix = fabric.util.composeMatrix({
                scaleX: options.scaleX,
                scaleY: options.scaleY,
                skewX: options.skewX
            });
            const wh = fabric.util.transformPoint(p, matrix);
            const strokeWidth = 1 / this.borderScaleFactor;
            const width = wh.x + strokeWidth;
            const height = wh.y + strokeWidth;

            ctx.save();
            this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);
            ctx.strokeStyle = styleOverride.borderColor || this.borderColor;

            ctx.strokeRect(
                -width / 2,
                -height / 2,
                width,
                height
            );

            ctx.restore();
            return this;
        }
    };

    fabric.Object.prototype.controls.ir = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetX: 0,
        offsetY: defaultSettings.innerRotateOffset,
        cursorStyle: `url("data:image/svg+xml;charset=utf-8,${rotateCursor}") 12 12, crosshair`,
        actionHandler: innerRotateObject,
        render: renderInnerRotateIcon,
        withConnection: true,
        actionName: 'innerRotate',
    });

    fabric.Object.prototype.controls.mtr = new fabric.Control({
        x: 0,
        y: -0.5,
        offsetX: 0,
        offsetY: -defaultSettings.rotatingPointOffset,
        cursorStyle: `url("data:image/svg+xml;charset=utf-8,${rotateCursor}") 12 12, crosshair`,
        actionHandler: fabric.controlsUtils.rotationWithSnapping,
        actionName: 'rotate',
        render: renderOuterRotateIcon,
        withConnection: true,
    });

    fabric.Object.prototype.controls.pan = new fabric.Control({
        x: 0,
        y: 0,
        offsetY: 0,
        offsetX: 0,
        cursorStyleHandler: panCursorStyleHandler,
        getActionHandler: getPanActionHandler,
        render: renderPanIcon,
        withConnection: true,
        getActionName: getPanActionName,
    });

    fabric.Object.prototype.controls.ml.render = renderCornerIcon;
    fabric.Object.prototype.controls.mr.render = renderCornerIcon;
    fabric.Object.prototype.controls.mb.render = renderCornerIcon;
    fabric.Object.prototype.controls.mt.render = renderCornerIcon;
    fabric.Object.prototype.controls.tl.render = renderCornerIcon;
    fabric.Object.prototype.controls.tr.render = renderCornerIcon;
    fabric.Object.prototype.controls.bl.render = renderCornerIcon;
    fabric.Object.prototype.controls.br.render = renderCornerIcon;

    fabric.Textbox.prototype.controls.mtr = fabric.Object.prototype.controls.mtr;
    fabric.Textbox.prototype.controls.mr.render = renderCornerIcon;
    fabric.Textbox.prototype.controls.ml.render = renderCornerIcon;

    fabric.Textbox.prototype.setControlsVisibility({
        mb: false,
        bl: false,
        br: false,
        mt: false,
        tl: false,
        tr: false,
    });

// commented out for now... maybe needed later
    /*function getRotateTopPosition(iconCurrentTopPosition: number): number {
      return iconCurrentTopPosition < 0
        ? -iconCurrentTopPosition
        : iconCurrentTopPosition;
    }*/

    function panCursorStyleHandler(): string {
        return 'move';
    }

    function getPanActionName(
        _: Event,
        __: fabric.Control,
        fabricObject: IEditorShape
    ): string {
        return fabricObject.photoObject && !fabricObject.photoObject.image ? 'drag' : CONTROL_PAN;
    }

    function getPanActionHandler(
        _: Event,
        fabricObject: IEditorShape
    ): fabric.ControlMouseEventHandler {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return fabricObject.photoObject && !fabricObject.photoObject.image && !fabricObject.pattern ? fabric.controlsUtils.dragHandler : () => {
            // do nothing
        };
    }

    function renderOuterRotateIcon(
        ctx: CanvasRenderingContext2D,
        left: number,
        top: number,
        _: object,
        fabricObject: fabric.Object
    ): void {
        if (!(fabricObject as IEditorShape).pattern) {
            const size = defaultSettings.rotateControlSize;
            // reposition the rotation icon for background object if it is above the canvas

            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle as number));
            ctx.drawImage(rotateControlImg, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    function renderInnerRotateIcon(
        ctx: CanvasRenderingContext2D,
        left: number,
        top: number,
        _: object,
        fabricObject: IEditorShape
    ): void {
        const size = defaultSettings.rotateControlSize;
        // reposition the rotation icon for background object if it is above the canvas
        if (fabricObject.photoObject && fabricObject.photoObject.image && !fabricObject.pattern) {
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle as number));
            ctx.drawImage(rotateControlImg, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    function renderPanIcon(
        ctx: CanvasRenderingContext2D,
        left: number,
        top: number,
        _: object,
        fabricObject: IEditorShape
    ): void {
        if (!fabricObject.pattern && fabricObject.photoObject && fabricObject.photoObject.image) {
            const size = defaultSettings.panControlSize;
            // circle
            ctx.beginPath();
            ctx.arc(left, top, 30, 0, 2 * Math.PI, false);
            ctx.fillStyle = 'rgba(185, 185, 185, 0.5)';
            ctx.fill();

            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle as number));
            ctx.drawImage(panControlImg, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    function renderCornerIcon(
        ctx: CanvasRenderingContext2D,
        left: number,
        top: number,
        _: object,
        fabricObject: fabric.Object
    ): void {
        if (!(fabricObject as IEditorShape).pattern) {
            const size = defaultSettings.controlSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle as number));
            ctx.drawImage(cornerControlImg, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    function innerRotateObject(
        _: Event,
        transform: ITransform,
        x: number,
        y: number
    ): boolean {
        if ((transform.target as IEditorShape).photoObject && !(transform.target as IEditorShape).pattern) {
            const lastAngle = Math.atan2(
                transform.ey - transform.original.top,
                transform.ex - transform.original.left
            );
            const curAngle = Math.atan2(
                y - transform.original.top,
                x - transform.original.left
            );
            const radians = curAngle - lastAngle + transform.innerTheta;
            let angle = fabric.util.radiansToDegrees(radians);

            // normalize angle to -180 180 value
            if (angle > 180) {
                angle -= 360;
            } else if (angle < -180) {
                angle += 360;
            }

            (transform.target as IEditorShape).innerRotate(angle);
            return true;
        }

        return false;
    }

    /**
     * Returns the instance of the control visibility set for this object.
     * hide mtr if tl is being used to rotate
     * @private
     * @returns {Object}
     */
    fabric.Object.prototype._getControlsVisibility = function (): { tl: boolean, tr: boolean, br: boolean, bl: boolean,
        ml: boolean, mt: boolean, mr: boolean, mb: boolean, mtr: boolean } {
        const mtrIsVisible = fabric.Object.prototype.handleLayout != HandleLayout.MOBILE && !this.locked && !this.fixed && !this.pattern;

        if (!this._controlsVisibility) {
            this._controlsVisibility = {
                tl: true,
                tr: true,
                br: true,
                bl: true,
                ml: true,
                mt: true,
                mr: true,
                mb: true
            };
        }

        this._controlsVisibility.mtr = mtrIsVisible;
        return this._controlsVisibility;
    };

    fabric.Object.prototype.getOffsetFromCanvasWrap = function (): number {
        return 0;
    };

    /////////////////////////////
    // Set Control Coordinates //
    /////////////////////////////
    fabric.Object.prototype.setCoords = function (ignoreZoom?: boolean): void {
        // call parent setCoords, which also calls setCornerCoords
        setCoords.call(this, false);
        if (!fabric.isLikelyNode) {
            // set coordinates for inner rotate and pan icon
            const coords = this.oCoords;
            const theta = fabric.util.degreesToRadians(this.angle);
            const sinTh = Math.sin(theta);
            const cosTh = Math.cos(theta);

            // add custom internal rotator if we are background type and have a wrap.
            const offsetY = this.type === 'background' ? this.getOffsetFromCanvasWrap() : 0;

            if (!ignoreZoom) {
                coords.ir = new fabric.Point(coords.mt.x + sinTh * this.innerRotateOffset, (coords.mt.y - cosTh * this.innerRotateOffset) + offsetY);
            }
            coords.pan = new fabric.Point(coords.tl.x + ((coords.br.x - coords.tl.x) / 2), coords.tl.y + ((coords.br.y - coords.tl.y) / 2));

            // set corner coords
            const newTheta = fabric.util.degreesToRadians(45 - this.angle);
            let cornerHypotenuse = Math.sqrt(2 * Math.pow(this.cornerSize, 2)) / 2;
            let cosHalfOffset = cornerHypotenuse * Math.cos(newTheta);
            let sinHalfOffset = cornerHypotenuse * Math.sin(newTheta);

            if (!ignoreZoom) {
                coords.ir.corner = {
                    tl: {
                        x: coords.ir.x - sinHalfOffset,
                        y: coords.ir.y - cosHalfOffset
                    },
                    tr: {
                        x: coords.ir.x + cosHalfOffset,
                        y: coords.ir.y - sinHalfOffset
                    },
                    bl: {
                        x: coords.ir.x - cosHalfOffset,
                        y: coords.ir.y + sinHalfOffset
                    },
                    br: {
                        x: coords.ir.x + sinHalfOffset,
                        y: coords.ir.y + cosHalfOffset
                    }
                };

            }

            // the pan icon has a different size
            // also add some padding 30 for circle 10 padding = 40
            cornerHypotenuse = Math.sqrt(2 * Math.pow(40, 2)) / 2;
            cosHalfOffset = cornerHypotenuse * Math.cos(newTheta);
            sinHalfOffset = cornerHypotenuse * Math.sin(newTheta);

            coords.pan.corner = {
                tl: {
                    x: coords.pan.x - sinHalfOffset,
                    y: coords.pan.y - cosHalfOffset
                },
                tr: {
                    x: coords.pan.x + cosHalfOffset,
                    y: coords.pan.y - sinHalfOffset
                },
                bl: {
                    x: coords.pan.x - cosHalfOffset,
                    y: coords.pan.y + sinHalfOffset
                },
                br: {
                    x: coords.pan.x + sinHalfOffset,
                    y: coords.pan.y + cosHalfOffset
                }
            };
        }
    };

    ////////////////////////////////////
    // Object Highlight Functionality //
    ////////////////////////////////////
    fabric.Object.prototype._setShadow = function (ctx: CanvasRenderingContext2D): void {
        const shadow = this.shadow || this.highlightShadow;
        if (!shadow) {
            return;
        }

        let multX;
        let multY;

        if (this._currentViewportTransform) {
            multX = this._currentViewportTransform[0];
            multY = this._currentViewportTransform[3];
        } else {
            multX = (this.canvas && this.canvas.viewportTransform[0]) || 1;
            multY = (this.canvas && this.canvas.viewportTransform[3]) || 1;
        }

        const scaling = this.getObjectScaling();
        if (this.canvas && this.canvas._isRetinaScaling()) {
            multX *= fabric.devicePixelRatio;
            multY *= fabric.devicePixelRatio;
        }

        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
        ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
        ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
    };

    /////////////////////////////////////////////////////////////
    // CANVAS - add functionality such as pan and inner rotate //
    /////////////////////////////////////////////////////////////
    // noinspection JSUnusedLocalSymbols
    globalImports.SF.Editor.Canvas = fabric.util.createClass(fabric.Canvas, {
        _previousMovePointer: null,
        objectsToLoad: 0,

        marginRight: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,

        initialize: function (el: HTMLElement, options: any): void {
            // define a proxy'd render all
            const renderAll = this._renderAll.bind(this);
            this.renderAll = function (): void {
                requestAnimationFrame(renderAll);
            };

            // default options
            options.preserveObjectStacking = true;
            options.backgroundColor = options.backgroundColor || '#FFFFFF';

            this.objectsToLoad = 0;
            this.callSuper('initialize', el, options);
            this.on('after:render', SF.Editor.PostRenderer.render.bind(this));
        },

        dispose: function (): void {
            this.off('after:render');
            this.forEachObject((object: any): void => {
                if (object.photoObject) {
                    object.photoObject.dispose();
                }
                if (object.frameObject) {
                    object.frameObject.dispose();
                }
            });
            if (this.wrapperEl.children && this.wrapperEl.children[0] instanceof HTMLCanvasElement) {
                this.wrapperEl.children[0].width = 0;
                this.wrapperEl.children[0].height = 0;
            }
            this.callSuper('dispose');
            if (fabric.filterBackend) {
                if (fabric.filterBackend.resources) {
                    if (fabric.filterBackend.resources.blurLayer1 && fabric.filterBackend.resources.blurLayer1 instanceof HTMLCanvasElement) {
                        fabric.filterBackend.resources.blurLayer1.width = 0;
                        fabric.filterBackend.resources.blurLayer1.height = 0;
                        fabric.filterBackend.resources.blurLayer1 = undefined;
                    }
                    if (fabric.filterBackend.resources.blurLayer2 && fabric.filterBackend.resources.blurLayer2 instanceof HTMLCanvasElement) {
                        fabric.filterBackend.resources.blurLayer2.width = 0;
                        fabric.filterBackend.resources.blurLayer2.height = 0;
                        fabric.filterBackend.resources.blurLayer2 = undefined;
                    }
                }
                fabric.filterBackend.dispose();
                fabric.filterBackend = null;
            }
        },

        destroy: function (): void {
            this.off('after:render');
        },

        /**
         * Custom render all for SF.Editor
         *
         */
        _renderAll: function (): fabric.StaticCanvas {
            if (!fabric.isLikelyNode && this.state && this.state.currentProject) {
                const project = this.state.currentProject;
                if (project.settings.isPagerViewModesVisible() && !this.state.groupCartItemIds && this.state.boardViewMode === SF.Model.ViewMode.SINGLE) {
                    this.skipOffscreen = false;
                }
            }
            const lowerContext = this.contextContainer;
            const upperContext = this.contextTop || this.contextContainer;
            let objsToRender;

            if (!upperContext) {
                return this;
            }
            // clear both context's
            this.clearContext(upperContext);
            this.clearContext(lowerContext);

            // fire before render
            this.fire('before:render');

            // apply clip
            FabricHelpers.clipContext(this, lowerContext);

            // render background (render's the white that is set in initialize())
            this._renderBackground(lowerContext);

            // render objects
            lowerContext.save();
            objsToRender = this._chooseObjectsToRender();

            //apply viewport transform once for all rendering process
            lowerContext.transform.apply(lowerContext, this.viewportTransform);
            for (let i = 0; i < objsToRender.length; i++) {
                if (objsToRender[i].type == 'group' && this.getObjects().indexOf(objsToRender[i]) >= 0) {
                    for (let j = 0; j < objsToRender[i]._objects.length; j++) {
                        objsToRender[i]._objects[j]._currentViewportTransform = this.viewportTransform;
                    }
                }
            }

            this._renderObjects(lowerContext, objsToRender);

            if (!this.preserveObjectStacking) {
                this._renderObjects(lowerContext, [this.getActiveGroup()]);
            }
            lowerContext.restore();


            FabricHelpers.unClipContext(this, lowerContext);


            // fire after-render
            this.fire('after:render');
            this.renderMasks();
            this.renderNonPrintableBackground();

            if (this.overlayImage && !fabric.isLikelyNode && !this.threeDpreview) {
                this._renderOverlay(lowerContext);
                this.drawControls(lowerContext);
            } else {
                this._renderOverlay(upperContext);
                // draw controls on upper layer
                this.drawControls(upperContext);
            }
            return this;
        },

        renderMasks: function (): void {
            // don't do anything -- override if needed
        },

        renderNonPrintableBackground: function (): void {
            // don't do anything -- override if needed
        },

        /**
         * @private
         * @param obj Object that was added
         */
        _onObjectAdded: function (obj: any): void {
            this.dirty = true;
            if (obj.type == 'group') {
                const innerObjects = obj.getObjects();
                for (let i = 0; i < innerObjects.length; i++) {
                    if (innerObjects[i].hasOwnProperty('ready') && !innerObjects[i].ready) {
                        // increment counter
                        this.objectsToLoad++;

                        // listen for ready
                        innerObjects[i].on('ready', this._onObjectReady.bind(this));
                    }
                }
            }
            if (obj.hasOwnProperty('ready') && !obj.ready) {
                // increment counter
                this.objectsToLoad++;

                // listen for ready
                obj.on('ready', this._onObjectReady.bind(this));
            }

            this.callSuper('_onObjectAdded', obj);
        },

        /**
         * @private
         * @param obj Object that was removed
         */
        _onObjectRemoved: function (obj: any): void {
            this.dirty = true;
            if (obj.hasOwnProperty('ready') && (obj.ready || obj.image === null)) {
                obj.off('ready', this._onObjectReady);
            }

            this.toolTipZones = [];

            this.callSuper('_onObjectRemoved', obj);
        },

        _onObjectReady: function (data: any): void {
            // do not decrease objectsToLoad if onObjectReady is called by a text object
            // Note: text objects are not counted by objectsToLoad but they still need to be ready before we can fire ready on canvas
            if (fabric.isLikelyNode || (this.objectsToLoad > 0 && data.target.type !== 'sf-text')) {
                this.objectsToLoad--;
            }
            if (this.objectsToLoad === 0) {
                let fontsLoaded: boolean = true;
                if (!fabric.isLikelyNode) {
                    const textObjects = this.getObjects().filter((object: IEditorShape) => {
                        return object.type === 'sf-text';
                    });

                    if (textObjects.length > 0) {
                        fontsLoaded = textObjects.every((textObj: any) => {
                            return textObj.ready;
                        });
                    }
                }
                if (fontsLoaded) {
                    if (!fabric.isLikelyNode) {
                        fabric.charWidthsCache = {};
                    }
                    this.renderAll();
                    this.fire('ready');
                }
            }

            data.target.off('ready', this._onObjectReady);
            if (data.target.group) {
                this._fire('modified', commonEventInfo(null, data.target.group, data.disableUndoManager));
            }
        },

        removeAll: function (): void {
            // remove all objects
            this.remove.apply(this, this.getObjects());
        },

        /////////////////////////////////////
        // OVERRIDE LAYERING FUNCTIONALITY //
        /////////////////////////////////////
        /**
         * Moves an object to the bottom of the stack of drawn objects
         */
        sendToBack: function (object: any): fabric.StaticCanvas {
            if (!object) {
                return this;
            }

            const activeGroup = this.getActiveGroup ? this.getActiveGroup() : null;
            let i;
            let obj;
            let objs;
            let newIndex;

            if (object === activeGroup) {
                objs = activeGroup._objects;
                for (i = objs.length; i--;) {
                    obj = objs[i];
                    // move to back
                    newIndex = this._findBackgroundIndexForObject(obj) + 1;
                    fabric.util.removeFromArray(this._objects, object);
                    this._objects.splice(newIndex, 0, object);
                }
            } else {
                // move to back
                newIndex = this._findBackgroundIndexForObject(object) + 1;
                fabric.util.removeFromArray(this._objects, object);
                this._objects.splice(newIndex, 0, object);
            }

            if (this.renderAll) {
                this.renderAll();
            }

            // let edits manager know
            this.fire('object:layer:changed', { target: object, index: newIndex });
            object.fire('layer:changed', { index: newIndex });

            return this;
        },

        /**
         * Moves an object to the top of the stack of drawn objects
         */
        bringToFront: function (object: any): fabric.StaticCanvas {
            this.callSuper('bringToFront', object);
            if (!this._currentTransform || this._currentTransform.action !== CONTROL_PAN) {
                this.fire('object:layer:changed', { target: object, index: this._objects.length - 1 });
            }
            object.fire('layer:changed', { index: this._objects.length - 1 });

            return this;
        },

        /**
         * Moves an object down in stack of drawn objects
         * @param object Object to send
         * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
         * @return {fabric.StaticCanvas} thisArg
         * @chainable
         */
        sendBackwards: function (object: any, intersecting: boolean): fabric.StaticCanvas {
            if (!object) {
                return this;
            }

            const activeGroup = this.getActiveGroup ? this.getActiveGroup() : null;
            let i;
            let obj;
            let idx;
            let newIdx;
            let objs;
            let minIndex;

            if (object === activeGroup) {

                objs = activeGroup._objects;
                for (i = 0; i < objs.length; i++) {
                    obj = objs[i];
                    minIndex = this._findBackgroundIndexForObject(obj) + 1;
                    idx = this._objects.indexOf(obj);
                    if (idx !== 0) {
                        newIdx = Math.max(minIndex, this._findNewLowerIndex(obj, idx, intersecting));
                        fabric.util.removeFromArray(this._objects, obj);
                        this._objects.splice(newIdx, 0, obj);
                    }
                }
            } else {
                idx = this._objects.indexOf(object);
                if (idx !== 0) {
                    // if object is not on the bottom of stack
                    minIndex = this._findBackgroundIndexForObject(object) + 1;
                    newIdx = Math.max(minIndex, this._findNewLowerIndex(object, idx, intersecting));
                    fabric.util.removeFromArray(this._objects, object);
                    this._objects.splice(newIdx, 0, object);
                }
            }

            if (this.renderAll) {
                this.renderAll();
            }
            this.fire('object:layer:changed', { target: object, index: newIdx });
            object.fire('layer:changed', { index: newIdx });

            return this;
        },

        /**
         * Moves an object up in stack of drawn objects
         * @param object Object to send
         * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
         * @return {fabric.StaticCanvas} thisArg
         * @chainable
         */
        bringForward: function (object: any, intersecting: boolean): fabric.StaticCanvas {
            this.callSuper('bringForward', object);

            const index = this._objects.indexOf(object);
            this.fire('object:layer:changed', { target: object, index: index });
            object.fire('layer:changed', { index: index });

            return this;
        },

        _findBackgroundIndexForObject: function (object: any): number {
            const idx = this._objects.indexOf(object);

            for (let i = idx - 1; i >= 0; i--) {
                const shape = this._objects[i];

                // note: if we want content to be above the given page's index, we can fix the following by adding:
                // && (object.intersectsWithObject(shape) || object.isContainedWithinObject(shape))
                if (shape instanceof SF.Editor.Background) {
                    return i;
                }
            }

            return -1;
        },

        //////////////////////////
        // ALIGNMENT  FUNCTIONS //
        //////////////////////////
        alignHorizontalLeft: function (objects: fabric.Object[]): void {
            const min: number = getFromObjects(objects, Math.min, function (o: fabric.Object): number {
                return (o.left || 0) - ((o.width || 0) * (o.scaleX || 0) / 2);
            });

            for (let i = 0; i < objects.length; i++) {
                objects[i].set('left', min + ((objects[i].width as number) * (objects[i].scaleX || 0) / 2));
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        alignHorizontalCenter: function (objects: any[]): void {
            const min = getFromObjects(objects, Math.min, function (o: any): number {
                return o.left - (o.width * o.scaleX / 2);
            });

            const max = getFromObjects(objects, Math.max, function (o: any): number {
                return o.left + (o.width * o.scaleX / 2);
            });

            const center = min + ((max - min) / 2);

            for (let i = 0; i < objects.length; i++) {
                objects[i].setLeft(center);
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        alignHorizontalRight: function (objects: any[]): void {
            const max = getFromObjects(objects, Math.max, function (o: any): number {
                return o.left + (o.width * o.scaleX / 2);
            });

            for (let i = 0; i < objects.length; i++) {
                objects[i].setLeft(max - (objects[i].width * objects[i].scaleX / 2));
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        alignVerticalTop: function (objects: any[]): void {
            const min = getFromObjects(objects, Math.min, function (o: any): number {
                return o.top - (o.height * o.scaleY / 2);
            });

            for (let i = 0; i < objects.length; i++) {
                objects[i].setTop(min + (objects[i].height * objects[i].scaleY / 2));
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        alignVerticalMiddle: function (objects: any[]): void {
            const min = getFromObjects(objects, Math.min, function (o: any): number {
                return o.top - (o.height * o.scaleY / 2);
            });
            const max = getFromObjects(objects, Math.max, function (o: any): number {
                return o.top + (o.height * o.scaleY / 2);
            });
            const middle = min + ((max - min) / 2);

            for (let i = 0; i < objects.length; i++) {
                objects[i].setTop(middle);
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        alignVerticalBottom: function (objects: any[]): void {
            const max = getFromObjects(objects, Math.max, function (o: any): number {
                return o.top + (o.height * o.scaleY / 2);
            });

            for (let i = 0; i < objects.length; i++) {
                objects[i].setTop(max - (objects[i].height * objects[i].scaleY / 2));
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        ////////////////////////////
        // DISTRIBUTION FUNCTIONS //
        ////////////////////////////
        /**
         *
         * @param {Array} objects
         * @param {Boolean} vertical
         * @param {String} edge - [ min, mid, max ]
         * @private
         */
        _distribute: function (objects: any[], vertical: boolean, edge: 'min' | 'mid' | 'max'): void {
            // distribution only works with more than two objects
            if (objects.length <= 2) {
                return;
            }

            // initialize variables
            const property = vertical ? 'top' : 'left';
            const dimension = vertical ? 'height' : 'width';
            const scale = vertical ? 'scaleY' : 'scaleX';

            // first, clone the array
            // we do this because all the javascript sorts are in place, and we want to be a good citizen
            objects = objects.slice(0);

            // define value adjustment function (value adjusted based on edge)
            const valueAdjustment = function (o: any): number {
                return edge === 'mid' ? 0 : (o[dimension] * o[scale] / 2) * (edge === 'max' ? -1 : 1);
            };

            // define value function that takes the edge adjustment into account
            const value = function (o: any): number {
                return o[property] - valueAdjustment(o);
            };

            // find the min object and remove it from array
            const minObject = getDistributionEdgeObject(objects, property, dimension, false);
            objects.splice(objects.indexOf(minObject), 1);

            // find the max object and remove it from array
            const maxObject = getDistributionEdgeObject(objects, property, dimension, true);
            objects.splice(objects.indexOf(maxObject), 1);

            // calculate distribution
            const min = value(minObject);
            const max = value(maxObject);
            const spacing = (max - min) / (objects.length + 1);

            // sort remaining objects by value function
            objects = sortObjectsByValueFunction(objects, value);

            // distribute
            for (let i = 0; i < objects.length; i++) {
                // move the object
                objects[i][vertical ? 'setTop' : 'setLeft'](value(minObject) + valueAdjustment(objects[i]) + (spacing * (i + 1)));

                // let the world know of movement
                this._dispatchCalculatedMove(objects[i]);
            }
        },

        _dispatchCalculatedMove: function (object: any): void {
            const group = object.group;
            if (group) {
                group._ungroupifyObject(object);
            }

            this._fire('moving', commonEventInfo(null, object));

            if (group) {
                group._groupifyObject(object);
            }
        },

        distributeVerticalTop: function (objects: any[]): void {
            return this._distribute(objects, true, 'min');
        },

        distributeVerticalMiddle: function (objects: any[]): void {
            return this._distribute(objects, true, 'mid');
        },

        distributeVerticalBottom: function (objects: any[]): void {
            return this._distribute(objects, true, 'max');
        },

        distributeHorizontalLeft: function (objects: any[]): void {
            return this._distribute(objects, false, 'min');
        },

        distributeHorizontalCenter: function (objects: any[]): void {
            return this._distribute(objects, false, 'mid');
        },

        distributeHorizontalRight: function (objects: any[]): void {
            return this._distribute(objects, false, 'max');
        },

        //////////////////////
        // OVERRIDE ACTIONS //
        //////////////////////
        /**
         * @private
         */
        _getActionFromCorner: function (alreadySelected: boolean, corner: string | boolean, e: Event, target: any): any {
            switch (corner) {
                case  INNER_ROTATION:
                    return 'innerRotate';
                case CONTROL_PAN:
                    return target.photoObject.image ? CONTROL_PAN : 'move';
                case GRAB_HANDLE_TOP_LEFT:
                    if (fabric.Object.prototype.handleLayout == HandleLayout.MOBILE) {
                        return 'move';
                    }
                    break;
                case GRAB_HANDLE_BOTTOM_LEFT:
                    if (fabric.Object.prototype.handleLayout == HandleLayout.MOBILE) {
                        return 'rotate';
                    }
                    break;
                default:
                // Do Nothing...
            }

            return this.callSuper('_getActionFromCorner', alreadySelected, corner, e, target);
        },

        /**
         * @private
         */
        _setupCurrentTransform: function (e: any, target: any): void {
            this._previousMovePointer = null;
            const alreadySelected: boolean = target === this._activeObject && target.__corner !== CONTROL_PAN;
            this.callSuper('_setupCurrentTransform', e, target, alreadySelected);

            if (this._currentTransform) {
                if (target.photoObject) {
                    this._currentTransform.zoom = target.getZoom();
                    this._currentTransform.innerTheta = fabric.util.degreesToRadians(target.getInnerRotation());
                    this._currentTransform.innerLeft = target.photoObject.left;
                    this._currentTransform.innerTop = target.photoObject.top;
                }

                this._currentTransform.height = target.height;
            }
        },

        setCursor: function (value: string, isImageEmpty?: boolean): void {
            if (value === 'clenchedFist') {
                value = 'url(' + SF.staticUrlRoot + 'images/editor/icons/icon_hand_closed.cur), move';
            } else if (value === 'move') {
                value = 'url(' + SF.staticUrlRoot + 'images/editor/icons/move.cur), move';
            } else if (value === 'rotate' && !isImageEmpty) {
                value = 'url(' + SF.staticUrlRoot + 'images/editor/icons/rotate.cur), crosshair';
            } else {
                if (value.substring(0,4) !== 'url(' && ['default', 'initial', 'text'].indexOf(value) === -1
                    && value != 'initial' && value != 'text' && !value.match(/(s|sw|se|e|ne|n|w|nw)-resize/)) {
                    console.warn('invalid value: ' + value);
                }
            }

            this.callSuper('setCursor', value);
        },

        getCornerCursor: function (corner: string, target: any, e: Event): string {
            if (corner === INNER_ROTATION || (corner === OUTER_ROTATION && target.hasRotatingPoint) ||
                (corner == GRAB_HANDLE_BOTTOM_LEFT && fabric.Object.prototype.handleLayout == SF.Model.HandleLayout.MOBILE)) {
                return 'rotate';
            } else if (corner === CONTROL_PAN || (corner == GRAB_HANDLE_TOP_LEFT &&
                fabric.Object.prototype.handleLayout == HandleLayout.MOBILE)) {
                return 'move';
            } else {
                return this.callSuper('getCornerCursor', corner, target, e);
            }
        },

        getActiveGroup: function (): IEditorPageGroup | null {
            const object = this.getActiveObject();
            if (object && (object.type == 'activeSelection' || object.type == 'group')) {
                return object;
            }
            return null;
        },

        /**
         * Scales object by invoking its scaleX/scaleY methods
         */
        scaleObject: function (e: Event | null, x: number, y: number, action: string): boolean {
            const t = this._currentTransform;
            const target = t.target;

            // get the constraint point
            const constraintPosition = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);
            let localMouse = target.toLocalPoint(new fabric.Point(x, y), t.originX, t.originY);
            let scaled = false;

            // set local mouse
            localMouse = getLocalMouse(t, localMouse, this.getZoom());

            if (target.mainType === 'shapeAsset' &&
                (target.type !== SF.Model.ShapeAssetTypes.Rectangle && target.type !== SF.Model.ShapeAssetTypes.Triangle)) {
                scaled = this._scaleCertainAssetShapes(action, localMouse, target);

            } else {
                if (action === 'scaleX') {
                    let w = localMouse.x / t.scaleX;

                    if (target.getMinWidth && target.getMinWidth() > w) {
                        w = target.getMinWidth();
                    }

                    target.set('width', w);
                    scaled = true;
                } else if (action === 'scaleY') {
                    let h = localMouse.y / t.scaleY;

                    if (target.getMinHeight && target.getMinHeight() > h) {
                        h = target.getMinHeight();
                    }

                    target.set('height', h);
                    scaled = true;
                } else {
                    // do it proportionally
                    const dist = localMouse.y + localMouse.x;
                    let strokeWidth;
                    strokeWidth = target.stroke ? target.strokeWidth : 0;
                    const lastDist = t.height + t.width + strokeWidth;
                    const width = (dist / lastDist) * t.width;
                    const height = (dist / lastDist) * t.height;

                    if (target.getMinWidth && target.getMinWidth() > width) {
                        return false;
                    }

                    if (target.getMinHeight && target.getMinHeight() > height) {
                        return false;
                    }

                    target.set('width', width);
                    target.set('height', height);
                    scaled = true;
                }

            }

            // make sure the constraints apply
            target.setPositionByOrigin(constraintPosition, t.originX, t.originY);

            // for certain edges the height/width of the photo object becomes zero during the group scaling process
            if (target.type == 'photo-group' && (target.photoObject.height == 0 || target.photoObject.width == 0)) {
                target.photoObject.placePhoto();
            }
            return scaled;
        },

        _scaleCertainAssetShapes(action: string, localMouse: any, target: any): boolean {
            let scaled = false;
            if (action === 'scaleX') {
                const w = localMouse.x;
                const ratio = w / target.width;
                target.set('scaleX', ratio);
                console.log(w);
                scaled = true;
            } else if (action === 'scaleY') {
                const h = localMouse.y;
                const ratio = h / target.height;
                target.set('scaleY', ratio);
                scaled = true;
            } else {
                let strokeWidth;
                const dist = localMouse.y + localMouse.x;
                strokeWidth = target.stroke ? target.strokeWidth : 0;
                const lastDist = target.width * target.scaleX + target.height * target.scaleY + strokeWidth;
                const ratio = dist / lastDist;
                let ratioX;
                let ratioY;
                if (target.type == SF.Model.ShapeAssetTypes.SpeechBubble) {
                    ratioX = ((target.getScaledWidth() - (strokeWidth * target.scaleX)) * ratio) / target.width;
                    ratioY = ((target.getScaledHeight() - (strokeWidth * target.scaleY)) * ratio) / target.height;
                } else {
                    ratioX = (target.getScaledWidth() * ratio) / target.width;
                    ratioY = (target.getScaledHeight() * ratio) / target.height;
                }
                target.set('scaleX', ratioX);
                target.set('scaleY', ratioY);
                scaled = true;
            }
            return scaled;
        },

        /**
         * Rotates object by invoking its rotate method
         * @private
         * @param {Number} x pointer's x coordinate
         * @param {Number} y pointer's y coordinate
         */
        _innerRotateObject: function (x: number, y: number): boolean {
            const t = this._currentTransform;

            if (t.target.photoObject) {
                const lastAngle = Math.atan2(t.ey - t.original.top, t.ex - t.original.left);
                const curAngle = Math.atan2(y - t.original.top, x - t.original.left);
                const radians = curAngle - lastAngle + t.innerTheta;
                let angle = fabric.util.radiansToDegrees(radians);

                // normalize angle to -180 180 value
                if (angle > 180) {
                    angle -= 360;
                } else if (angle < -180) {
                    angle += 360;
                }

                t.target.innerRotate(angle);
                return true;
            }

            return false;
        },

        /**
         * Pan's a photo
         *
         * @private
         * @param {Number} x pointer's x coordinate
         * @param {Number} y pointer's y coordinate
         */
        _pan: function (x: number, y: number): boolean {
            const t = this._currentTransform;
            const target = t.target;

            if (target.photoObject) {
                // calculate delta
                let dX;
                let dY;

                if (!this._previousMovePointer) {
                    dX = x - t.original.left;
                    dY = y - t.original.top;
                } else {
                    dX = x - this._previousMovePointer.x;
                    dY = y - this._previousMovePointer.y;
                }

                if (target.angle) {
                    const radians = fabric.util.degreesToRadians(-target.angle);
                    const sin = Math.sin(radians);
                    const cos = Math.cos(radians);
                    const rx = dX * cos - dY * sin;
                    const ry = dX * sin + dY * cos;

                    dX = rx;
                    dY = ry;
                }

                if (target.flipX) {
                    dX = -dX;
                }

                if (target.flipY) {
                    dY = -dY;
                }

                target.pan(dX, dY);
                return true;
            }

            return false;
        },

        _getOverlappingObjects: function (object: any, accum: any[]): any[] {
            const objects = this.getObjects();
            const objectIndex = objects.indexOf(object);
            const remainder = objects.slice(objectIndex + 1);
            const self = this;

            // init accumulator
            accum = accum || [];

            remainder.map(function (o: any): void {
                if (accum.indexOf(o) === -1 && (o.intersectsWithObject(object) || o.isContainedWithinObject(object))) {
                    // add object
                    accum.push(o);

                    // check if object overlaps with others
                    self._getOverlappingObjects(o, accum);
                }
            });

            return accum;
        },

        ///////////////////////
        // OVERRIDE GROUPING //
        ///////////////////////
        _createGroupFromObjects: function (objects: any[]): IEditorEditorGroup {
            const canvasObjects = this.getObjects();
            objects = objects.map((object: any) => {
                if (object.mainType && object.mainType == 'shapeAsset' && !(object instanceof fabric.Object)) {
                    const shapeAssetObjects = canvasObjects.filter((obj: any) => {
                        return obj.uid == object.uid;
                    })[0];
                    return shapeAssetObjects[0] || null;
                } else {
                    return object;
                }
            });

            return new SF.Editor.Group(objects, {
                canvas: this
            });
        },

        /**
         * @private
         * @param {Object} target
         */
        _createGroup: function (target: any): IEditorPageGroup | null {

            const objects = this.getObjects();
            let isActiveLower;
            let groupObjects;
            const isActiveObjectGroup = this._activeObject.group;
            if (isActiveObjectGroup && objects.indexOf(isActiveObjectGroup._findGroupByUid(this)) >= 0) {
                const group = isActiveObjectGroup._findGroupByUid(this);
                this.setActiveObject(group);
                isActiveLower = objects.indexOf(group) < objects.indexOf(target);
                groupObjects = isActiveLower
                    ? [group, target]
                    : [target, group];
            } else {
                isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target);
                groupObjects = isActiveLower
                    ? [this._activeObject, target]
                    : [target, this._activeObject];
            }
            if (this._activeObject.isEditing) {
                this._activeObject.exitEditing();
            }

            return this._createGroupFromObjects(groupObjects);
        },

        ////////////////////////////
        // MULTI SELECT OVERRIDES //
        ////////////////////////////
        /**
         * @private
         */
        _collectObjects: function (): fabric.Object[] {
            const group: fabric.Object[] = [];
            let currentObject: fabric.Object;
            const x1 = this._groupSelector.ex;
            const y1 = this._groupSelector.ey;
            const x2 = x1 + this._groupSelector.left;
            const y2 = y1 + this._groupSelector.top;
            const selectionX1Y1 = new fabric.Point(Math.min(x1, x2), Math.min(y1, y2));
            const selectionX2Y2 = new fabric.Point(Math.max(x1, x2), Math.max(y1, y2));
            const isClick = x1 === x2 && y1 === y2;

            for (let i = this._objects.length; i--;) {
                currentObject = this._objects[i];

                if (!currentObject || !currentObject.selectable || !currentObject.visible || (currentObject as any).locked) {
                    continue;
                }

                if (currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2)) {
                    group.push(currentObject);

                    // only add one object if it's a click
                    if (isClick) {
                        break;
                    }
                }
            }

            return group;
        },

        /**
         * @private
         * @param {Event} e mouse event
         */
        _groupSelectedObjects: function (e: Event): void {

            let group = this._collectObjects();

            // do not create group for 1 element only
            if (group.length === 1) {
                this.setActiveObject(group[0], e);
            } else if (group.length > 1) {
                group = this._createGroupFromObjects(group.reverse());
                if (group) {
                    this.setActiveObject(group, e);
                }
            }

        },

        /**
         * @private
         * @param {Event} e Event object
         * @param target
         */
        _handleGrouping: function (e: Event, target: any): void {
            const activeObject = this._activeObject;
            // avoid multi select when shift click on a corner
            if (activeObject.__corner) {
                return;
            }
            if (target === activeObject) {
                // if it's a group, find target again, using activeGroup objects
                target = this.findTarget(e, true);
                // @note background check is the only modification
                if (!target || target.isType('group') || target.isType('background')) {
                    return;
                }
            }
            if (activeObject && activeObject.type === 'group') {
                this._updateActiveSelection(target, e);
            } else {
                this._createActiveSelection(target, e);
            }

        },

        /**
         * @private
         */
        _clearSelection: function (e: Event, target: any, pointer: { x: number, y: number }): void {

            const isBackgroundAction = this.isBackgroundAction(target, pointer);

            // clean all
            this.discardActiveObject(e);

            // either select object or create group selector
            if (target && target.selectable && (target.type !== 'background' || (target.type === 'background' && isBackgroundAction))) {
                this.setActiveObject(target, e);
            } else if (this.selection) {
                this._groupSelector = {
                    ex: pointer.x,
                    ey: pointer.y,
                    top: 0,
                    left: 0
                };
            }
        },

        /**
         * @private
         * @param {Event} e Event object
         * @param target
         */
        _shouldClearSelection: function (e: Event, target: any): boolean {
            const activeGroup = this.getActiveGroup();
            const activeObject = this.getActiveObject();

            // if there is no target, return
            if (!target) {
                return true;
            }

            if (activeGroup && !activeGroup.contains(target) && activeGroup !== target && !(e as any)[this.selectionKey]) {
                return true;
            }

            if (!target.evented) {
                return true;
            }

            if (activeObject && activeObject.type === 'background') {
                return true;
            }

            if (target.type === 'background') {
                return !([CONTROL_PAN, INNER_ROTATION].indexOf(target._findTargetCorner(this.getPointer(e, true))) >= 0 && (!activeGroup || !activeGroup.contains(target)));
            }

            return !target.selectable && activeObject && activeObject !== target;
        },

        /**
         * @private
         */
        _searchPossibleTargets: function (objects: any[], pointer: any): any {

            // Cache all targets where their bounding box contains point.
            let target;
            let i = objects.length;
            // Do not check for currently grouped objects, since we check the parent group itself.
            // until we call this function specifically to search inside the activeGroup
            while (i--) {
                if (!(objects[i] instanceof SF.Editor.Foreground) && this._checkTarget(pointer, objects[i]) && !objects[i].pattern) {
                    target = objects[i];
                    if (target.type === 'group' && target.subTargetCheck) {
                        const normalizedPointer = this._normalizePointer(target, pointer);
                        const subTarget = this._searchPossibleTargets(target._objects, normalizedPointer);
                        if (subTarget) {
                            this.targets.push(subTarget);
                        }
                    }
                    break;
                }
            }

            return target;
        },

        isBackgroundAction: function (target: fabric.Object, pointer: { x: number, y: number }): boolean {
            return target && target.type === 'background' && [CONTROL_PAN, INNER_ROTATION].indexOf((target as any)._findTargetCorner(pointer)) >= 0;
        },

        showHideCustomControls: function (): void {
            // Default canvas doesn't have any custom controls...
        },

        _checkTarget: function (pointer: fabric.Point, obj: fabric.Object, callSuper?: boolean): boolean {

            if (!callSuper && (pointer.x < this.marginLeft || pointer.x > this.width - this.marginRight || pointer.y < this.marginTop || pointer.y > this.height - this.marginBottom)) {
                if (this.editsManager) {
                    const visiblePages = this.editsManager.getVisiblePages();
                    let totalWidth = 0;
                    visiblePages.forEach((page: IEditorPage) => {
                        totalWidth += page.width;
                    });
                    let heightRange: number;
                    const currentPage = this.editsManager.getCurrentPage();
                    if (currentPage) {
                        heightRange = currentPage.height * this.getZoom() + this.marginTop;
                    } else {
                        heightRange = this.editsManager.getVisiblePages()[0].height * this.getZoom() + this.marginTop;
                    }
                    const widthRange = totalWidth * this.getZoom() + this.marginLeft;
                    const outOfBoundPointer = pointer.x < this.marginLeft || pointer.x > widthRange || pointer.y < this.marginTop || pointer.y > heightRange;
                    if (outOfBoundPointer) {
                        return false;
                    }

                } else {
                    return false;
                }
            }

            if (obj.type == 'clipart' && obj.containsPoint(pointer)) {
                if (!callSuper) {
                    const isTargetTransparent = this.isTargetTransparent(obj, pointer.x, pointer.y);
                    const hasBackgroundObject = EditorHelpers.hasBackgroundObject(this);
                    if (!obj.selectable || (isTargetTransparent && !hasBackgroundObject)) {
                        return false;
                    }
                }
            }
            return this.callSuper('_checkTarget', pointer, obj);
        },

        findTarget: function (e: Event, skipGroup: boolean): fabric.Object | null {
            if (this.skipTargetFind) {
                return null;
            }

            const ignoreZoom = true;
            const pointer = this.getPointer(e, ignoreZoom);
            const activeGroup = this.getActiveGroup();
            const activeObject = this.getActiveObject();
            let activeTarget;

            // first check current group (if one exists)
            // active group does not check sub targets like normal groups.
            // if active group just exits.
            if (activeGroup && !skipGroup && activeGroup === this._searchPossibleTargets([activeGroup], pointer)) {
                this._fireOverOutEvents(activeGroup, e);
                return activeGroup;
            }
            // if we hit the corner of an activeGroup, returns that
            if (activeGroup && activeGroup._findTargetCorner(pointer)) {
                this._fireOverOutEvents(activeGroup, e);
                return activeGroup;
            }

            // if we hit the corner of an activeObject, let's return that.
            if (activeObject && activeObject._findTargetCorner(pointer)) {
                this._fireOverOutEvents(activeObject, e);
                return activeObject;
            }
            if (activeObject && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
                if (!this.preserveObjectStacking) {
                    this._fireOverOutEvents(activeObject, e);
                    return activeObject;
                } else {
                    activeTarget = activeObject;
                }
            }

            this.targets = [];
            let target = this._searchPossibleTargets(this._objects, pointer);
            if ((e as any)[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
                target = activeTarget;
            }
            this._fireOverOutEvents(target, e);
            return target;
        }

    });

    fabric.util.object.extend(fabric.IText.prototype, {

        /**
         * Initializes hidden textarea (needed to bring up keyboard in iOS)
         */
        initHiddenTextarea: function (): void {
            // var p;
            // if (e && this.canvas) {
            //     p = this.canvas.getPointer(e);
            // }
            // else {
            //     this.oCoords || this.setCoords();
            //     p = this.oCoords.tl;
            // }

            this.hiddenTextarea = fabric.document.createElement('textarea');
            this.hiddenTextarea.setAttribute('autocapitalize', 'off');
            const style = this._calcTextareaPosition();
            this.hiddenTextarea.style.cssText = 'white-space: nowrap; position: absolute; top: ' + style.top +
                '; left: ' + style.left + '; opacity: 0; width: 1px; height: 1px; z-index: -999;';
            this.cursorWidth = 3;
            fabric.document.body.appendChild(this.hiddenTextarea);
            fabric.util.addListener(this.hiddenTextarea, 'focus', this.onTextFocus.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
            fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));

            if (!this._clickHandlerInitialized && this.canvas) {
                fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
                this._clickHandlerInitialized = true;
            }
        },

        onTextFocus: function (): void {
            if (window.scrollY > 0) {
                const board = document.getElementsByTagName('board');
                if (board && board.length > 0) {
                    board[0].scrollTop = window.scrollY;
                }
                window.scrollBy(0, -window.scrollY);
            }
        },

        renderCursor: function (boundaries: any, ctx: CanvasRenderingContext2D): void {
            const cursorLocation = this.get2DCursorLocation();
            const lineIndex = cursorLocation.lineIndex;
            const charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0;
            const charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize');
            const multiplier = this.scaleX * this.canvas.getZoom();
            const cursorWidth = this.cursorWidth / multiplier;
            let topOffset = boundaries.topOffset;
            const dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');

            topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);

            if (this.inCompositionMode) {
                this.renderSelection(boundaries, ctx);
            }
            const brightnessValue = 123;
            let fillStyle = ctx.fillStyle;
            ctx.fillStyle = this.getCurrentCharColor(lineIndex, charIndex);
            ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
            const top = parseInt(this._calcTextareaPosition().top.replace('px', ''), 10) - this.canvas._offset.top;
            const left = parseInt(this._calcTextareaPosition().left.replace('px', ''), 10) - this.canvas._offset.left;
            const cursorHeight = charHeight * this.get('scaleY');
            const context = this.canvas.lowerCanvasEl.getContext('2d', { willReadFrequently: true });
            const data = context.getImageData(left, top - cursorHeight, Math.ceil(this.cursorWidth), cursorHeight).data;
            const avgRGB = getAverageRGBColor(data, 1);
            if (avgRGB.r == 0 && avgRGB.g == 0 && avgRGB.b == 0) {
                if (avgRGB.a == 0 || avgRGB.a < 0.5) {
                    fillStyle = '#000000';
                } else if (avgRGB.a == 1 || avgRGB.a >= 0.5) {
                    fillStyle = '#FFFFFF';
                }
            } else if (isBrighterThan(avgRGB.r, avgRGB.g, avgRGB.b, brightnessValue)) {
                fillStyle = '#000000';
            } else {
                fillStyle = '#FFFFFF';
            }
            ctx.fillStyle = fillStyle;
            ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
            ctx.fillRect(
                boundaries.left + boundaries.leftOffset - cursorWidth / 2,
                topOffset + boundaries.top + dy,
                cursorWidth,
                charHeight);

        },

        renderKeyHole: (): void => {
            console.log('If you want to render the keyhole, you must override this function in the appropriate canvas file');
        },

        onMouseDown: function (options: any): void {
            if (!this.canvas) {
                return;
            }
            this.__newClickTime = +new Date();
            const newPointer = options.pointer;
            if (this.isTripleClick(newPointer)) {
                this.fire('tripleclick', options);
                this._stopEvent(options.e);
            }
            if (this.isDoubleClick(newPointer)) {
                this.fire('dblclick', options);
                this._stopEvent(options.e);
            }
            this.__lastLastClickTime = this.__lastClickTime;
            this.__lastClickTime = this.__newClickTime;
            this.__lastPointer = newPointer;
            this.__lastIsEditing = this.isEditing;
            this.__lastSelected = this.selected;
        },
    });

    ///////////////////
    // STATIC CANVAS //
    ///////////////////
    /**
     * This has intentionally different logic than the SF.Editor.Canvas. The static canvas
     * only calls renderAll() when all objects are ready, whereas the Canvas calls it every time
     * an object is ready.
     */
    SF.Editor.StaticCanvas = fabric.util.createClass(fabric.StaticCanvas, {
        objectsToLoad: 0,

        initialize: function (el: HTMLElement, options: any): void {
            this.objectsToLoad = 0;
            this.renderOnAddRemove = false;
            this.callSuper('initialize', el, options);
            this.on('after:render', SF.Editor.PostRenderer.render.bind(this));
        },

        removeAll: function (): void {
            // remove all objects
            this.remove.apply(this, this.getObjects());
        },

        /**
         * @private
         * @param obj Object that was added
         */
        _onObjectAdded: function (obj: any): void {
            if (obj.type == 'group') {
                const innerObjects = obj.getObjects();
                for (let i = 0; i < innerObjects.length; i++) {
                    if (innerObjects[i].hasOwnProperty('ready') && !innerObjects[i].ready) {
                        // increment counter
                        this.objectsToLoad++;

                        // listen for ready
                        innerObjects[i].on('ready', this._onObjectReady.bind(this));
                    }
                }
            }
            if (obj.hasOwnProperty('ready') && !obj.ready) {
                // increment counter
                this.objectsToLoad++;

                // listen for ready
                obj.on('ready', this._onObjectReady.bind(this));
            }

            this.callSuper('_onObjectAdded', obj);
        },

        /**
         * @private
         * @param obj Object that was removed
         */
        _onObjectRemoved: function (obj: any): void {
            if (obj.hasOwnProperty('ready') && (obj.ready || obj.image === null)) {
                obj.off('ready', this._onObjectReady);
            }
            this.callSuper('_onObjectRemoved', obj);
        },

        _onObjectReady: function (data: any): void {
            let fontsLoaded: boolean = true;
            if (!fabric.isLikelyNode) {
                const textObjects = this.getObjects().filter((object: IEditorShape) => {
                    return object.type === 'sf-text';
                });

                if (textObjects.length > 0) {
                    fontsLoaded = !textObjects.find((textObj: IEditorShape) => {
                        return !(textObj as any).ready;
                    });
                }
            }
            // do not decrease objectsToLoad if onObjectReady is called by a text object
            // Note: text objects are not counted by objectsToLoad but they still need to be ready before we can fire ready on canvas
            if (fabric.isLikelyNode || (this.objectsToLoad > 0 && data.target.type !== 'sf-text')) {
                this.objectsToLoad--;
            }
            if (this.objectsToLoad === 0 && fontsLoaded) {
                if (!fabric.isLikelyNode) {
                    fabric.charWidthsCache = {};
                }
                this.renderAll();
                this.fire('ready');

            }

            data.target.off('ready', this._onObjectReady);
        },

        dispose: function (): void {
            // cancel eventually ongoing renders
            if (this.isRendering) {
                fabric.util.cancelAnimFrame(this.isRendering);
                this.isRendering = 0;
            }
            this.forEachObject(function (disposeObject: any): void {
                if (disposeObject.dispose) {
                    disposeObject.dispose();
                }
                if (disposeObject.photoObject) {
                    disposeObject.photoObject.dispose();
                }
                if (disposeObject.frameObject) {
                    disposeObject.frameObject.dispose();
                }
            });
            this._objects = [];
            if (this.backgroundImage && this.backgroundImage.dispose) {
                this.backgroundImage.dispose();
            }
            this.backgroundImage = null;
            if (this.overlayImage && this.overlayImage.dispose) {
                this.overlayImage.dispose();
            }
            this.overlayImage = null;
            this._iTextInstances = null;
            fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
            return this;
        },
    });

    ///////////////////
    // POST RENDERER //
    ///////////////////
    SF.Editor.PostRenderer = ((): IPostRender => {
        return {
            render: render,
            drawBorder: drawBorder,
            drawMirror: drawMirror,
            drawExtend: drawExtend,
            drawImageWrapWithBlur: drawImageWrapWithBlur,
            drawMirrorWithBlur: drawMirrorWithBlur,
            renderMask: renderMask,
            copyCanvas: copyCanvas,
            loadingPatternImage: loadingPatternImage,
            disposeCopiedCanvas: disposeCopiedCanvas,
        };

        function render(): void {

            const isEditor = this instanceof SF.Editor.Canvas;

            if (this.overlayImage && !fabric.isLikelyNode) {
                if (!this.threeDpreview) {
                    this._renderOverlay(this.contextContainer);
                } else {
                    const upperContext = this.contextTop || this.contextContainer;
                    this._renderOverlay(upperContext);
                }
            }

            if ((!this.wrap || (isEditor && this.state && !this.state.showWrap))
                && !this.keyhole && !this.maskBW && !this.nonPrintableBackground && !this.maskMerge &&
                (!this.coverPageBleed || fabric.isLikelyNode)) {
                return;
            }

            if (this.keyhole && this.editsManager) {
                this.renderKeyHole();
            } else if ((this.maskBW || this.maskMerge) && SF.Editor.PostRenderer.renderMask) {
                SF.Editor.PostRenderer.renderMask(this);
            } else if (this.coverPageBleed && SF.Editor.PostRenderer.renderCoverPageBleed) {
                SF.Editor.PostRenderer.renderCoverPageBleed.apply(this);
            } else if (this.nonPrintableBackground && SF.Editor.PostRenderer.renderNonPrintableBackground) {
                SF.Editor.PostRenderer.renderNonPrintableBackground(this);
            } else {
                renderWrap.bind(this)(isEditor);
            }
        }

        function copyCanvas(canvas: HTMLCanvasElement): HTMLCanvasElement {
            // tslint:disable-next-line:no-require-imports
            const copiedCanvas = fabric.util.createCanvasElement();
            copiedCanvas.width = canvas.width;
            copiedCanvas.height = canvas.height;
            const ctx = copiedCanvas.getContext('2d');
            ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height);
            return copiedCanvas;
        }

        function disposeCopiedCanvas(canvas: HTMLCanvasElement): void {
            canvas.width = 0;
            canvas.height = 0;
            (canvas as any) = null;
        }

        function drawBorder(ctx: CanvasRenderingContext2D, color: string, marginLeft: number, marginTop: number, left: number, top: number, bottom: number, right: number, width: number, height: number): void {
            ctx.fillStyle = color;
            ctx.fillRect(marginLeft, marginTop, left, height);
            ctx.fillRect(marginLeft + width - right, marginTop, right, height);
            ctx.fillRect(marginLeft + left, marginTop, width - left - right, top);
            ctx.fillRect(marginLeft + left, marginTop + height - bottom, width - left - right, bottom);
        }

        function drawMirror(ctx: CanvasRenderingContext2D, marginLeft: number, marginTop: number, left: number, top: number, bottom: number, right: number, width: number, height: number, threeDpreview: boolean): void {
            // setTransform resets all the previous transformations. We need to restore device pixel ratio after setTransform.
            const copiedCanvas = copyCanvas(ctx.canvas);

            // if threeDpreview is true it means that we are called from the renderer class (used for drawing 3D preview).
            const ratio = threeDpreview ? 1 : fabric.devicePixelRatio;

            ctx.setTransform(-1, 0, 0, 1, 0, 0);
            // left and right
            ctx.drawImage(copiedCanvas, (marginLeft + left) * ratio, marginTop * ratio, left * ratio, height * ratio, (-marginLeft - left) * ratio, marginTop * ratio, left * ratio, height * ratio);
            ctx.drawImage(copiedCanvas, (marginLeft + width - right - left) * ratio, marginTop * ratio, left * ratio, height * ratio, (-marginLeft - width) * ratio, marginTop * ratio, left * ratio, height * ratio);

            // top and bottom
            ctx.setTransform(1, 0, 0, -1, 0, 0);
            ctx.drawImage(copiedCanvas, marginLeft * ratio, (marginTop + top) * ratio, width * ratio, top * ratio, marginLeft * ratio, (-marginTop - top) * ratio, width * ratio, top * ratio);
            ctx.drawImage(copiedCanvas, marginLeft * ratio, (marginTop + height - top - bottom) * ratio, width * ratio, top * ratio, marginLeft * ratio, (-marginTop - height) * ratio, width * ratio, top * ratio);
            disposeCopiedCanvas(copiedCanvas);
        }

        function drawMirrorWithBlur(ctx: CanvasRenderingContext2D, marginLeft: number, marginTop: number, left: number, top: number, bottom: number, right: number, width: number, height: number, threeDpreview: boolean): void {

            const filters: any[] = [];
            filters.push(new fabric.Image.filters.Blur({blur: 0.05}));
            //   const copiedCanvas: HTMLCanvasElement = copyCanvas(ctx.canvas);
            let copiedCanvas: HTMLCanvasElement | null = null;
            const originalFabricTextureSize = fabric.textureSize;
            let textureSizeChanged: boolean = false;
            if (!fabric.isLikelyNode) {
                copiedCanvas = SF.Editor.PostRenderer.copyCanvas(ctx.canvas);
                if (fabric.textureSize < Math.max(copiedCanvas.width, copiedCanvas.height)) {
                    fabric.textureSize = defaultSettings.maxTextureSize;
                    textureSizeChanged = true;
                    if (fabric.filterBackend) {
                        fabric.filterBackend.dispose();
                        fabric.filterBackend = null;
                    }
                }
            }

            if (!fabric.filterBackend) {
                fabric.filterBackend = fabric.initFilterBackend();
            }

            // setTransform resets all the previous transformations. We need to restore device pixel ratio after setTransform.
            let ratio;
            // if threeDpreview is true it means that we are called from the renderer class (used for drawing 3D preview).
            if (threeDpreview) {
                ratio = 1;
            } else {
                ratio = fabric.devicePixelRatio;
            }

            if (!fabric.isLikelyNode && copiedCanvas) {
                fabric.filterBackend.applyFilters(filters, copiedCanvas, copiedCanvas.width, copiedCanvas.height, copiedCanvas);
                ctx.save();
                // left and right
                ctx.setTransform(-1, 0, 0, 1, 0, 0);
                ctx.drawImage(copiedCanvas, (marginLeft + left) * ratio, marginTop * ratio, (left * ratio) + 1, height * ratio,
                    (-marginLeft - left) * ratio - 1, marginTop * ratio, left * ratio + 1, height * ratio);
                ctx.drawImage(copiedCanvas, (marginLeft + width - 2 * right) * ratio, marginTop * ratio, right * ratio, height * ratio,
                    (-marginLeft - width) * ratio, marginTop * ratio, right * ratio, height * ratio);

                // top and bottom
                ctx.setTransform(1, 0, 0, -1, 0, 0);
                ctx.drawImage(copiedCanvas, marginLeft * ratio, ((marginTop + top) * ratio) + 1, width * ratio, top * ratio,
                    marginLeft * ratio, (-marginTop - top) * ratio - 1, width * ratio, top * ratio + 1);
                ctx.drawImage(copiedCanvas, marginLeft * ratio, (marginTop + height - 2 * bottom) * ratio, width * ratio, bottom * ratio,
                    marginLeft * ratio, (-marginTop - height) * ratio, width * ratio, bottom * ratio);
                ctx.restore();
            } else {
                const blurredCanvas = fabric.util.createCanvasElement();
                blurredCanvas.width = ctx.canvas.width - ((marginLeft + left + right) * ratio);
                blurredCanvas.height = ctx.canvas.height - ((marginTop + top + bottom) * ratio);
                const blurredCanvasCtx = blurredCanvas.getContext('2d');
                blurredCanvasCtx.drawImage(ctx.canvas, (marginLeft + left) * ratio, (marginTop + top) * ratio, blurredCanvas.width, blurredCanvas.height, 0, 0, blurredCanvas.width, blurredCanvas.height);
                fabric.filterBackend.applyFilters(filters, blurredCanvas, blurredCanvas.width, blurredCanvas.height, blurredCanvas);

                const newCanvas = fabric.util.createCanvasElement();
                newCanvas.width = ctx.canvas.width;
                newCanvas.height = ctx.canvas.height;
                const newCanvasCtx = newCanvas.getContext('2d');
                newCanvasCtx.drawImage(blurredCanvas, 0, 0, blurredCanvas.width, blurredCanvas.height, (marginLeft + left) * ratio, (marginTop + top) * ratio, blurredCanvas.width, blurredCanvas.height);

                ctx.save();
                // left and right
                ctx.setTransform(-1, 0, 0, 1, 0, 0);
                ctx.drawImage(newCanvas, (marginLeft + left) * ratio, marginTop * ratio, (left * ratio) + 1, height * ratio,
                    (-marginLeft - left) * ratio - 1, marginTop * ratio, left * ratio + 1, height * ratio);
                ctx.drawImage(newCanvas, (marginLeft + width - 2 * right) * ratio, marginTop * ratio, right * ratio, height * ratio,
                    (-marginLeft - width) * ratio, marginTop * ratio, right * ratio, height * ratio);

                // top and bottom
                ctx.setTransform(1, 0, 0, -1, 0, 0);
                ctx.drawImage(newCanvas, marginLeft * ratio, ((marginTop + top) * ratio) + 1, width * ratio, top * ratio,
                    marginLeft * ratio, (-marginTop - top) * ratio - 1, width * ratio, top * ratio + 1);
                ctx.drawImage(newCanvas, marginLeft * ratio, (marginTop + height - 2 * bottom) * ratio, width * ratio, bottom * ratio,
                    marginLeft * ratio, (-marginTop - height) * ratio, width * ratio, bottom * ratio);
                ctx.restore();
            }
            if (textureSizeChanged) {
                fabric.textureSize = originalFabricTextureSize;
                fabric.filterBackend.dispose();
                fabric.filterBackend = null;
            }
        }

        function drawImageWrapWithBlur(ctx: CanvasRenderingContext2D, marginLeft: number, marginTop: number, left: number, top: number, bottom: number, right: number, width: number, height: number, threeDpreview: boolean): void {

            const filters: any[] = [];
            filters.push(new fabric.Image.filters.Blur({blur: 0.5}));
            const copiedCanvas: HTMLCanvasElement = copyCanvas(ctx.canvas);
            const originalFabricTextureSize = fabric.textureSize;
            let textureSizeChanged: boolean = false;
            if (!fabric.isLikelyNode && fabric.textureSize < Math.max(copiedCanvas.width, copiedCanvas.height)) {
                fabric.textureSize = defaultSettings.maxTextureSize;
                textureSizeChanged = true;
                if (fabric.filterBackend) {
                    fabric.filterBackend.dispose();
                    fabric.filterBackend = null;
                }
            }
            if (!fabric.filterBackend) {
                fabric.filterBackend = fabric.initFilterBackend();
            }
            fabric.filterBackend.applyFilters(filters, copiedCanvas, copiedCanvas.width, copiedCanvas.height, copiedCanvas);

            let ratio;
            // if threeDpreview it means that we are called from the renderer class (used for drawing 3D preview).
            if (threeDpreview) {
                ratio = 1;
            } else {
                ratio = fabric.devicePixelRatio;
            }
            // left and right
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(copiedCanvas, marginLeft * ratio, (top + marginTop) * ratio, left * ratio, (height - bottom - top) * ratio,
                marginLeft * ratio, (top + marginTop) * ratio, left * ratio, (height - bottom - top) * ratio);
            ctx.drawImage(copiedCanvas, (width + marginLeft - right) * ratio, (top + marginTop) * ratio, right * ratio, (height - bottom - top) * ratio,
                (width + marginLeft - right) * ratio, (top + marginTop) * ratio, right * ratio, (height - bottom - top) * ratio);

            // top and bottom
            ctx.drawImage(copiedCanvas, (marginLeft + left) * ratio, marginTop * ratio, (width - left - right) * ratio, top * ratio,
                (marginLeft + left) * ratio, marginTop * ratio, (width - left - right) * ratio, top * ratio);
            ctx.drawImage(copiedCanvas, (marginLeft + left) * ratio, (marginTop + height - bottom) * ratio, (width - left - right) * ratio, bottom * ratio,
                (marginLeft + left) * ratio, (marginTop + height - bottom) * ratio, (width - left - right) * ratio, bottom * ratio);
            if (textureSizeChanged) {
                fabric.textureSize = originalFabricTextureSize;
                fabric.filterBackend.dispose();
                fabric.filterBackend = null;
            }
        }

        // We are picking 3 pixels for the extend
        function drawExtend(ctx: CanvasRenderingContext2D, marginLeft: number, marginTop: number, left: number, top: number, bottom: number, right: number, width: number, height: number, threeDpreview: boolean): void {
            let ratio;
            // if threeDpreview it means that we are called from the renderer class (used for drawing 3D preview).
            if (threeDpreview) {
                ratio = 1;
            } else {
                ratio = fabric.devicePixelRatio;
            }
            ctx.setTransform(1, 0, 0, 1, 0, 0);

            // left and right
            ctx.drawImage(ctx.canvas, (marginLeft + left + 1) * ratio, (top + marginTop) * ratio, 3 * ratio, (height - bottom - top) * ratio,
                marginLeft * ratio, (top + marginTop) * ratio, (left) * ratio, (height - bottom - top) * ratio);
            ctx.drawImage(ctx.canvas, (width + marginLeft - right - 4) * ratio, (top + marginTop) * ratio, 3 * ratio, (height - bottom - top) * ratio,
                (width + marginLeft - right) * ratio, (top + marginTop) * ratio, right * ratio, (height - bottom - top) * ratio);

            // top and bottom
            ctx.drawImage(ctx.canvas, (marginLeft + left) * ratio, (marginTop + top + 1) * ratio, (width - left - right) * ratio, 3 * ratio,
                (marginLeft + left) * ratio, marginTop * ratio, (width - left - right) * ratio, top * ratio);
            ctx.drawImage(ctx.canvas, (marginLeft + left) * ratio, (marginTop + height - bottom - 4) * ratio, (width - left - right) * ratio, 3 * ratio,
                (marginLeft + left) * ratio, (marginTop + height - bottom) * ratio, (width - left - right) * ratio, bottom * ratio);
        }

        function renderWrap(isEditor: boolean): void {
            const ctx = this.getContext();
            const zoom = this.getZoom();
            const marginTop = isEditor ? this.marginTop : 0;
            const marginLeft = isEditor ? this.marginLeft : 0;

            // side (wrap)
            const lSide = Math.round((this.wrap)[EditorBleedProperties.BLEED_SIDE_LEFT] * zoom);
            const rSide = Math.round((this.wrap)[EditorBleedProperties.BLEED_SIDE_RIGHT] * zoom);
            const tSide = Math.round((this.wrap)[EditorBleedProperties.BLEED_SIDE_TOP] * zoom);
            const bSide = Math.round((this.wrap)[EditorBleedProperties.BLEED_SIDE_BOTTOM] * zoom);

            // back side (bleed)
            const lBack = Math.round((this.wrap)[EditorBleedProperties.BLEED_BACK_LEFT] * zoom);
            const rBack = Math.round((this.wrap)[EditorBleedProperties.BLEED_BACK_RIGHT] * zoom);
            const tBack = Math.round((this.wrap)[EditorBleedProperties.BLEED_BACK_TOP] * zoom);
            const bBack = Math.round((this.wrap)[EditorBleedProperties.BLEED_BACK_BOTTOM] * zoom);

            // aggregate
            const left = lSide + lBack;
            const top = tSide + tBack;
            const right = rSide + rBack;
            const bottom = bSide + bBack;
            let height = Math.round(this.wrap.height * zoom);
            let width = Math.round(this.wrap.width * zoom);
            let drawWrap = false;

            // editsManager is not in the Node Canvas ( SF.Editor.StaticCanvas) so it cannot be used to
            // get the width and height.  Resort to the old way with the wrap if we are in node canvas.
            //  If we don't yet have the editsManager, and we are not Node, don't draw the wrap...
            if (this.editsManager) {
                height = Math.round(this.editsManager.getCurrentPage().height * zoom);
                width = Math.round(this.editsManager.getCurrentPage().width * zoom);
                drawWrap = true;
            } else if (!isEditor) {
                drawWrap = true;
            }

            const threeDpreviewBoard = !!this.threeDpreview;

            ctx.save();
            if (drawWrap) {
                if ((this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.BORDER || (this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.BORDER_WHITE) {
                    drawBorder(ctx, (this.wrap)[WrapOptions.EDGE_COLOR], marginLeft, marginTop, left, top, bottom, right, width, height);
                } else if ((this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.MIRROR_WRAP) {
                    if (SF.Editor.PostRenderer.drawMirror) {
                        SF.Editor.PostRenderer.drawMirror(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                    }
                } else if ((this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.MIRROR_WRAP_WITH_BLUR) {
                    if (this.objectsToLoad == 0) {
                        if (SF.Editor.PostRenderer.drawMirrorWithBlur) {
                            SF.Editor.PostRenderer.drawMirrorWithBlur(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                        }
                    }
                } else if ((this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.IMAGE_WRAP_WITH_BLUR) {
                    if (SF.Editor.PostRenderer.drawImageWrapWithBlur) {
                        SF.Editor.PostRenderer.drawImageWrapWithBlur(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                    }
                } else if ((this.wrap)[WrapOptions.EDGE_STYLE] === globalImports.SF.Model.EdgeStyles.EXTEND) {
                    if (this.objectsToLoad == 0) {
                        if (SF.Editor.PostRenderer.drawExtend) {
                            SF.Editor.PostRenderer.drawExtend(ctx, marginLeft, marginTop, left, top, bottom, right, width, height, threeDpreviewBoard);
                        }
                    }
                }
            }

            ctx.restore();
        }

        // noinspection JSUnusedLocalSymbols
        function renderMask(canvas: IEditorCanvas): void {
            // override for different applications
        }

        function loadingPatternImage() : void {
            // override for different applications
        }
    })();

    ///////////////////////
    // PRIVATE FUNCTIONS //
    ///////////////////////
    function getFromObjects(objects: any[], comparator: (a: any, b: any) => number, value: (val: any) => number): any {
        return objects.reduce(function (a: any, b: any): any {
            return comparator(a instanceof Object ? value(a) : a, value(b));
        });
    }

    function sortObjectsByValueFunction(objects: any[], valueFunction: (val: any) => number): any[] {
        return objects.sort(function (a: any, b: any): number {
            return valueFunction(a) > valueFunction(b) ? 1 : -1;
        });
    }

    function getDistributionEdgeObject(objects: any[], property: string, dimension: string, max: boolean): any {
        const invertAdjustment = max ? -1 : 1;

        // sort first
        objects.sort(function (a: any, b: any): number {
            return a[property] - (a[dimension] / 2) * invertAdjustment > b[property] - (b[dimension] / 2) * invertAdjustment ? 1 : -1;
        });

        // return relevant object
        return objects[max ? objects.length - 1 : 0];
    }


